import { styled } from '@mui/material'
import { COLORS } from 'src/styles/common'

export const TopDivider = styled('div') <{
  bgColor?: string
}>`
  width: 100%;
  height: 22px;
  background-color: ${(props) => props?.bgColor || COLORS.PRIMARY};
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
`

export const LeftDivider = styled('div')<{
  bgColor?: string
}>(({ theme, bgColor }) => ({
  position: 'fixed',
  top: 0,
  bottom: 0,
  left: 0,
  width: 22,
  backgroundColor: bgColor || COLORS.PRIMARY,
  zIndex: 100,
  pointerEvents: 'none',
  [theme.breakpoints.down('md')]: {
    width: 8,
  },
}))
